import './App.css';
import { BrowserRouter, Switch, Route } from 'react-router-dom'
import Home from './pages/Home/Home'
import About from './pages/About/About';
import Download from './pages/Download/Download';
function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Switch>
          <Route path='/' exact component={Home} />
          <Route path='/about' exact component={About} />
          <Route path='/download' exact component={Download} />
        </Switch>
      </div>
    </BrowserRouter>
  );
}

export default App;
